/**
 * Route constants for the Portal context. Re-exported from
 * `contexts/PortalContext.tsx`, so every existing import from that path keeps
 * working unchanged.
 */

/** Routes. Staff sign-in and the admin area are deliberately separate URLs. */
export const CLIENT_PATH = '/client'
export const STAFF_PATH = '/staff'
export const ADMIN_PATH = '/admin'
/** Where a Supabase staff invitation link lands. */
export const STAFF_SETUP_PATH = '/staff/setup-password'
/** Where a resent staff setup link lands. Same screen. */
export const STAFF_RESET_PATH = '/staff/reset-password'
/**
 * Preview as Client.
 *
 * Not a route of its own: staff open the project's real client link with
 * ?preview=1 appended, so the same URL, the same loader and the same screens
 * the client gets. The flag only means something to a verified staff session,
 * and all it does is withhold every action that would write.
 */
export const PREVIEW_PARAM = 'preview'
